export default import.meta.ROLLDOWN_FILE_URL_jZ9cU1LEbzRmEgHwK8PQ0g